import { atom } from 'jotai';

export const show_UploadTask_UploadPanel_Atom = atom<boolean>(false);
export const uploadTaskPreloadedFilesAtom = atom<File[]>([]);
